<template>
  <div class="overflow-hidden">
    <div class="container flex min-h-screen">
      <div class="flex flex-col flex-1 pb-8 min-h-full">
        <form
          :action="action"
          class="flex-1"
          method="POST"
          novalidate
          @submit.prevent="submit"
        >
          <header class="mb-4">
            <div class="container -mx-4 md:-mx-8 flex h-14 md:h-20 py-3 md:py-4">
              <Link class="h-full -ml-1 md:ml-0" :href="route('home')">
                <img class="block h-full pb-[2%]" src="/media/Onlineshop_KM_RGB.svg" alt="DAS DA Kulturmanagement">
              </Link>
            </div>
            <div class="hidden lg:block mb-12 mt-4">
              <Steps
                :step="step"
                :order="order"
                :steps="steps"
              />
            </div>
          </header>

          <details class="lg:hidden bg-gray-100 overflow-hidden rounded-md mb-8 border border-gray-300">
            <summary class="px-5 py-3 cursor-pointer">
              Bestellung
              <strong class="float-right">{{ formatPrice(order.cart.total_discounted) }}</strong>
            </summary>
            <div class="px-5 pt-2 pb-3 border-t border-gray-300">
              <Cart
                class="border-gray-300"
                :cart="order.cart"
              />
            </div>
          </details>

          <div class="lg:hidden mb-8">
            <Steps
              :step="step"
              :order="order"
              :steps="steps"
            />
          </div>

          <main>
            <slot name="default" v-bind="{ openModal }" />
          </main>

          <footer class="sm:flex sm:flex-row-reverse items-center justify-between mt-12 text-center">
            <button
              class="button w-full sm:w-auto"
              type="submit"
              :data-fb-track="dataFbTrack"
              :data-fb-data="dataFbData"
            >
              {{ actionText }}
            </button>
            <Link
              v-if="back"
              :href="back"
              class="inline-flex items-center underline text-blue-500 mt-6 sm:mt-0 text-sm"
            >
              <Icon
                type="angle-left"
                class="mr-2"
                size="3"
              />
              {{ backText }}
            </Link>
          </footer>
        </form>

        <div class="mt-8 pt-8 border-t">
          <div class="flex flex-wrap -mt-2 -ml-4 text-sm text-gray-800">
            <div v-for="(link ,key) in links" :key="key" class="pt-2 pl-4">
              <a
                :href="link.href"
                class="underline"
                @click="openModal"
              >
                {{ link.text }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <aside class="hidden lg:block flex-1 pt-24 pb-16 pl-16 ml-16 relative max-w-md">
        <div class="w-screen absolute left-0 top-0 bottom-0 bg-gray-200 z-[-1]" />
        <Cart :cart="order.cart" />
      </aside>

    </div>
  </div>

  <Dialog
    ref="dialog"
    :autofocus="false"
    :cancel="false"
    size="2xl"
    @submit="$refs.dialog.close()"
  >
    <h2 class="text-2xl mb-8 text-blue-500">
      {{ state.headline ?? state.title }}
    </h2>
    <div class="text" v-html="state.content" />
  </Dialog>
</template>

<script>
import Dialog from 'Web/Dialogs/Dialog.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import Cart from 'Web/Checkout/Cart.vue';
import Steps from 'Web/Checkout/Steps.vue';
import useMeta from '@/compose/meta';
import { reactive, ref } from 'vue';
import formatPrice from '@/helpers/formatPrice';
import Http from '@/helpers/http';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
  inheritAttrs: false,
  components: {
    Dialog,
    Icon,
    Link,
    Cart,
    Steps,
  },
  props: {
    action: String,
    actionText: String,
    back: String,
    backText: String,
    order: Object,
    step: String,
    steps: Object,
    submit: Function,
    dataFbTrack: String,
    dataFbData: String,
  },
  setup() {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Checkout' });

    const dialog = ref(null);

    const state = reactive({
      title: null,
      headline: null,
      content: null,
    });

    async function openModal(event) {
      event.preventDefault();

      const { version } = usePage();

      const response = await Http.get(event.target.href, {
        headers: {
          'X-Inertia': true,
          'X-Inertia-Version': version.value,
        }
      });

      Object.assign(state, response.props);

      dialog.value.open();
    }

    const links = [
      {
        href: route('pages.right-of-withdrawal'),
        text: 'Widerrufsbelehrung',
      },
      {
        href: route('pages.shipping-and-payment'),
        text: 'Versand & Zahlung',
      },
      {
        href: route('pages.data-protection'),
        text: 'Datenschutzerklärung',
      },
      {
        href: route('pages.terms-and-conditions'),
        text: 'AGB',
      },
      {
        href: route('pages.imprint'),
        text: 'Impressum',
      },
    ]

    return {
      dialog,
      formatPrice,
      links,
      openModal,
      state,
    }
  }
}
</script>
